import React, {useState, useEffect} from "react";
import Weather from "./Weather";
import Forecast from "./Forecast";
import "../styles/WeatherAndForecast.css";
import {Chart} from "react-google-charts";

function WeatherAndForecast({weatherInfo, location}) {
    const date = dateBuilder(new Date());

    function dateBuilder(d) {
        const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ];

        const date = [];
        for (let count = 0; count < 5; count++) {
            if (d.getDay() + count < 7) 
                date[count] = d.getDay() + count;
            else if (d.getDay() + count === 7) 
                date[count] = 0;
            else if (d.getDay() + count === 8) 
                date[count] = 1;
            else if (d.getDay() + count === 9) 
                date[count] = 2;
            else if (d.getDay() + count === 10) 
                date[count] = 3;
            }
        
        return [
            days[date[0]],
            days[date[1]],
            days[date[2]],
            days[date[3]],
            days[date[4]]
        ];
    }

    const dataHumidity = [
        ["Day", "Humidity"],
        [date[0], weatherInfo.daily[0].humidity],
        [date[1], weatherInfo.daily[1].humidity],
        [date[2], weatherInfo.daily[2].humidity],
        [date[3], weatherInfo.daily[3].humidity]
    ];

    const dataPressure = [
        ["Day", "Pressure"],
        [date[0], weatherInfo.daily[0].pressure],
        [date[1], weatherInfo.daily[1].pressure],
        [date[2], weatherInfo.daily[2].pressure],
        [date[3], weatherInfo.daily[3].pressure]
    ];

    const dataTemp = [
        ["Day", "Temperature"],
        [date[0], weatherInfo.daily[0].temp.day],
        [date[1], weatherInfo.daily[1].temp.day],
        [date[2], weatherInfo.daily[2].temp.day],
        [date[3], weatherInfo.daily[3].temp.day]
    ];

    const optionsTemp = {
        legend: {
            position: "top"
        },
        width: "300px",
        height: "150px",
        backgroundColor: "none",
        colors: ['#F7B32F']
    };

    const optionsHumidity = {
        legend: {
            position: "top"
        },
        width: "300px",
        height: "150px",
        backgroundColor: "none",
        colors: ['#b86229']
    };

    const optionsPressure = {
        legend: {
            position: "top"
        },
        width: "500px",
        height: "150px",
        backgroundColor: "none",
        colors: ['#D65529']
    };

    return (
        <div className="WeatherAndForecast">
            <Weather weatherInfo={weatherInfo} location={location} date={date[0]}/>
            <div className="WeatherAndForecast__container">
                <Forecast weatherInfo={weatherInfo.daily[0]} date={date[0]}/>
                <Forecast weatherInfo={weatherInfo.daily[1]} date={date[1]}/>
                <Forecast weatherInfo={weatherInfo.daily[2]} date={date[2]}/>
                <Forecast weatherInfo={weatherInfo.daily[3]} date={date[3]}/>
                <Forecast weatherInfo={weatherInfo.daily[4]} date={date[4]}/>
            </div>
            <div className="WeatherAndForecast__graphs">
                <Chart
                    chartType="AreaChart"
                    data={dataTemp}
                    options={optionsTemp}
                    legendToggle/>
                <Chart
                    chartType="AreaChart"
                    title="humidity"
                    data={dataHumidity}
                    options={optionsHumidity}/>
                <Chart
                    chartType="AreaChart"
                    data={dataPressure}
                    options={optionsPressure}
                    legendToggle/>

            </div>
        </div>
    );
};

export default WeatherAndForecast;
